import React, { useCallback, useMemo } from 'react'
import { divider } from '@groovehq/internal-design-system/lib/styles/elements'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getNodeByKey, $getSelection } from 'lexical'
import DateTimeInputSinglePane from 'shared/components/ui/DateTimeInputSinglePane'
import { getOffsetTimeFromMidnight, mergeDateAndTime } from 'util/date'
import { DATE_SEARCH_DATE_INPUT, DATE_SEARCH_TIME_INPUT } from './util'
import { DATE_QUERY_COMMAND } from './PlainTextEditor/DatePlugin'

const startOfToday = getOffsetTimeFromMidnight(new Date(), -24, 'hours')

const DateTimeInputPane = ({ onSearchBoxBlur, value, setValue }) => {
  const [editor] = useLexicalComposerContext()

  const handleConfirm = useCallback(
    () => {
      editor.dispatchCommand(DATE_QUERY_COMMAND, { value })
    },
    [editor, value]
  )

  const handleCancel = useCallback(
    () => {
      editor.dispatchCommand(DATE_QUERY_COMMAND)
    },
    [editor]
  )

  const mergedDateAndTime = useMemo(
    () => {
      let result = value.date
      if (!result) {
        const editorState = editor.getEditorState()
        editorState.read(() => {
          const selection = $getSelection()
          if (selection) {
            const dateFilterNode = $getNodeByKey($getSelection().anchor.key)
            result = dateFilterNode.getFilterName().endsWith('before:')
              ? new Date()
              : startOfToday
          } else {
            result = new Date()
          }
        })
      } else if (value.time) {
        result = mergeDateAndTime(result, value.time)
      }
      return result
    },
    [value.time, value.date, editor]
  )

  return (
    <>
      <DateTimeInputSinglePane
        onChange={setValue}
        onSetInitialValue={setValue}
        // Disable future dates
        toDate={new Date()}
        value={mergedDateAndTime}
        timeInputId={DATE_SEARCH_TIME_INPUT}
        dateInputId={DATE_SEARCH_DATE_INPUT}
        onInputBlur={onSearchBoxBlur}
        isControlled
      />
      <div css={divider.styles.primary} role="separator" />
      <div className="grui py-8 px-10">
        <Button size="small" type="info" onClick={handleConfirm}>
          Confirm
        </Button>
        <Button
          size="small"
          type="tertiary"
          className="grui ml-8"
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </div>
    </>
  )
}

export default DateTimeInputPane
